/**
 * Deliberately naive and capped at two glyphs. Names here span scripts and conventions —
 * mononyms, patronymics, Tamil initials-first ordering — so anything cleverer would be
 * confidently wrong for some employees. Two graphemes from the first two words is predictable.
 */
export function initials(name: string): string {
  return [...name.trim().split(/\s+/).slice(0, 2)]
    .map((part) => [...part][0] ?? '')
    .join('')
    .toUpperCase();
}
